import React from 'react';
import { Head, Link } from '@inertiajs/react';

export default function Sessions({ sessions, current_session_id, csrf_token }) {
  return (
    <>
      <Head title="Active Sessions" />
      <div className="min-h-screen bg-gray-50">
        <nav className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex">
                <div className="flex-shrink-0 flex items-center">
                  <h1 className="text-xl font-bold text-indigo-600">Rezy</h1>
                </div>
                <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                  <Link 
                    href="/" 
                    className="text-gray-500 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium"
                  >
                    Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </nav>

        <div className="py-10">
          <header>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold text-gray-900">Active Sessions</h1>
            </div>
          </header>
          <main>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="bg-white shadow overflow-hidden sm:rounded-lg mt-6">
                <div className="px-4 py-5 sm:p-6">
                  <div className="mt-2">
                    <ul className="divide-y divide-gray-200">
                      {sessions.map((session) => (
                        <li key={session.id} className="py-4 flex justify-between">
                          <div className="ml-3">
                            <p className="text-sm font-medium text-gray-900">
                              {session.id === current_session_id ? 'Current Session' : 'Session'}
                            </p>
                            <p className="text-sm text-gray-500">
                              {new Date(session.created_at).toLocaleString()}
                            </p>
                            <p className="text-sm text-gray-500">
                              {session.user_agent}
                            </p>
                            <p className="text-sm text-gray-500">
                              IP: {session.ip_address}
                            </p>
                          </div>
                          {session.id !== current_session_id && (
                            <form method="POST" action={`/sessions/${session.id}`}>
                              <input type="hidden" name="_method" value="delete" />
                              <input type="hidden" name="authenticity_token" value={csrf_token} />
                              <button
                                type="submit"
                                className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                              >
                                Sign Out
                              </button>
                            </form>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="mt-6">
                    <Link
                      href="/"
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Back to Home
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
